import { type ApolloClient, type DocumentNode, type NormalizedCacheObject } from '@apollo/client'
import {
  type Exact,
  type QuerySearchResultsPageArgs,
  type SearchQueryInput,
  type SearchResultsPage,
} from '@kijiji/generated/graphql-types'

export type GetSearchResultsPage = Exact<{
  searchResultsPage: SearchResultsPage
}>

export const getResults = async (
  searchQueryInput: SearchQueryInput,
  apolloClient: ApolloClient<NormalizedCacheObject>,
  query: DocumentNode
) => {
  return await apolloClient.query<GetSearchResultsPage, QuerySearchResultsPageArgs>({
    query,
    variables: {
      by: {
        query: searchQueryInput,
      },
      pagination: {
        limit: 0,
      },
    },
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  })
}
